<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Born in Felixstowe, Franky moved to North Suffolk as a small child. She still lives close to the Norfolk/Suffolk border with her husband, John, and their dog.</p><br/>
<p style="text-indent: 00em;">Franky trained as a shorthand/typist/secretary and worked as such in a variety of industries, including a rock and sweet making factory, an offshore oil and gas platform construction company and as a local government officer. Other employment include music engraving and over two decades as a parish council clerk.</p><br/>
<p style="text-indent: 00em;">Her hobbies include music – she plays tenor recorder, guitar, piano and church organ, and the last of these led to her becoming the chapel organist for twenty years in a local prison.</p><br/>
<p style="text-indent: 00em;">Her other interests are artistic roller skating – she is a member of the Waveney Roller Skating Club; dressmaking, walking her dog in the countryside and reading.</p><br/>
<p style="text-indent: 00em;">This is Franky’s first novel and also the first in <em>The PepperAsh</em> series.</p><br/>
<p style="text-indent: 00em;">If you would like to know more about Franky and to follow her on Facebook, please go to ‘Franky Sayer Author’.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?70c2d868